import { IThemeStyles, IBGParams } from '@bg-shared/integrations/shared/interfaces';
import { EventTypes } from '@bg-shared/integrations/shared/EventTypes';
import { WINDOW_NAME } from '@bg-shared/integrations/shared/constants';
import { getSource } from './utils/getSource';
import { validateBgParams } from './utils/validateBgParams';
import { themeEditor } from './themeEditor';
import { setupPMContracts } from './postMessenger/setupPMContracts';
import { createPostMessenger, IPostMessageApi } from './postMessenger/createPostMessenger';

export default (() => {
    let iFrame: HTMLIFrameElement = null;
    let pm: IPostMessageApi = null;
    let index = 0;

    const setup = (bgParams: IBGParams, newIntegration = true): void => {
        try {
            const params = validateBgParams(bgParams);

            if (!params) {
                return;
            }

            const bFrame = document.createElement('iframe');

            index++;

            const name = `${WINDOW_NAME}${!newIntegration ? `_${index}` : ''}`;

            bFrame.setAttribute('name', name);
            bFrame.setAttribute('id', name);
            bFrame.setAttribute('frameborder', '0');
            bFrame.setAttribute(
                'allow',
                'autoplay; fullscreen; encrypted-media; clipboard-write; clipboard-read',
            );
            bFrame.setAttribute('scrolling', 'no');
            bFrame.setAttribute('src', getSource(params, newIntegration));
            bFrame.style.minWidth = '100%';
            bFrame.style.display = 'block';

            const container = document.getElementById(params.containerId);

            container.appendChild(bFrame);

            iFrame = document.getElementById(params.containerId).firstChild as HTMLIFrameElement;

            pm = createPostMessenger(iFrame.contentWindow);

            setupPMContracts(pm, iFrame);
        } catch (error) {
            console.error('BetGames loader: error in setup ', error);
        }
    };

    return {
        setup,

        // legacy
        frame: (bgParams: Array<[string, string]>) => {
            const params = Object.fromEntries(bgParams) as unknown as IBGParams;

            if (!params.containerId) {
                const id = 'betgames_div_iframe';

                params.containerId = id;

                if (!document.getElementById(id)) {
                    document.write(`<div id="${id}"></div>`);
                }
            }

            setup(params, false);
        },

        onThemeEditorReady: themeEditor.onReady,

        setThemeStyles: (data: IThemeStyles) => {
            if (!themeEditor.isReady()) {
                console.error(
                    'Iframe theme styles are not ready. Use BetGames.onThemeEditorReady() for initial load.',
                );
                return;
            }

            if (pm) {
                pm.emit({
                    type: EventTypes.SET_THEME,
                    payload: {
                        themeData: data,
                    },
                });
            }
        },
    };
})();
